/* Shared by the hero logo row and the sticky product rail. `lockup` is the
   vertical logo with the name beneath; `mark` is the icon alone, both trimmed
   to their content. `anchor` is the id of the matching section on /home. */
export const PRODUCTS = [
    {
        name: "RentDirect",
        tagline: "Bookings & Storefronts",
        anchor: "rent-direct",
        lockup: { src: "/images/products/direct.png", width: 370, height: 344 },
        mark: { src: "/images/products/mark-direct.png", width: 208, height: 174 },
    },
    {
        name: "RentShield",
        tagline: "Insurance & Protections",
        anchor: "rent-shield",
        lockup: { src: "/images/products/shield.png", width: 248, height: 244 },
        mark: { src: "/images/products/mark-shield.png", width: 128, height: 148 },
    },
    {
        name: "RentID",
        tagline: "Driver Verification Tools",
        anchor: "rent-id",
        lockup: { src: "/images/products/id.png", width: 229, height: 361 },
        mark: { src: "/images/products/mark-id.png", width: 192, height: 217 },
    },
    {
        name: "RentSuccess",
        tagline: "Back office & Resolution Center",
        anchor: "rent-success",
        lockup: { src: "/images/products/success.png", width: 461, height: 365 },
        mark: { src: "/images/products/mark-success.png", width: 220, height: 220 },
    },
    {
        name: "RentAI",
        tagline: "AI Agents & Automations",
        anchor: "rent-ai",
        lockup: { src: "/images/products/ai-light.png", width: 263, height: 352 },
        mark: { src: "/images/products/mark-ai.png", width: 180, height: 208 },
    },
    {
        name: "RentAcademy",
        tagline: "Education & Training",
        anchor: "rent-academy",
        lockup: { src: "/images/products/academy.png", width: 164, height: 129 },
        mark: { src: "/images/products/mark-academy.png", width: 75, height: 75 },
    },
];
